import axios from "axios";
import Vue from "vue";

let sessionId = window.name;

export default {
  state: () => ({
    callCenterUCId: null,
    callCenterShowUCIdAlert: null,
  }),

  mutations: {
    setCallCenterUCId(state, ucId) {
      Vue.set(state, "callCenterUCId", ucId);
    },
    setCallCenterShowUCIdAlert(state, alert) {
      Vue.set(state, "callCenterShowUCIdAlert", alert);
    },
    resetPaymentModule(state) {
      Vue.set(state, "callCenterShowUCIdAlert", null);
      Vue.set(state, "callCenterUCId", null);
    },
  },

  actions: {
    IVRTransferCallCenter: (context, request) =>
      axios
        .post(`${context.getters.getCrsServiceUrl}/rail-ivr/transfer-call-center-call`, request)
        .then((response) => response)
        .catch((err) => err.response),

    IVRPaymentCheck: (context, request) =>
      axios
        .get(`${context.getters.getCrsServiceUrl}/rail-ivr/call-center-payment-check/${request.transactionCode}`)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        }),
  },

  getters: {
    getCallCenterUCId: (state) => state.callCenterUCId,
    isCallCenterShowUCIdAlert: (state) => state.callCenterShowUCIdAlert,
  },
};
